import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  link: {
    textDecoration: 'underline',
  },
}))

export default styles
